import PropTypes from 'prop-types';
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { isUserAllowed } from "../../../shared/utils";
import { ROLES } from "../../../helper/constants";

const ContactModalPhonesForm = ({ onChangePhone, onRemove, phone, index }) => (
  <Row key={index} className="mt-6 crm-contact-modal-forms-container">
    <Col sm="2">
      <FormGroup>
        <Label className="label_autofin" for="profile">Código</Label>
        <Input
          className="mb-2"
          maxLength="3"
          onChange={onChangePhone('code', index)}
          value={phone.code}
          placeholder="Código"
          required
          disabled
        />
      </FormGroup>
    </Col>
    <Col sm="4">
      <FormGroup>
        <Label className="label_autofin" for="profile">Teléfono</Label>
        <Input
          className="mb-2"
          maxLength="9"
          minLength="9"
          onChange={onChangePhone('number', index)}
          value={phone.number}
          disabled={isUserAllowed(ROLES.auditor)}
          required
        />
      </FormGroup>
    </Col>
    {!isUserAllowed(ROLES.auditor) &&
      <Col sm="1" className="mt-4">
        <button className="mb-2 plus_add2" onClick={onRemove(index)} size="sm">
          <span className="lnr lnr-lnr lnr-trash" style={{ fontWeight: 'bold', cursor: 'pointer', }} />
        </button>
      </Col>}
  </Row>
);

ContactModalPhonesForm.propTypes = {
  onChangePhone: PropTypes.func,
  onRemove: PropTypes.func,
  phone: PropTypes.shape({
    code: PropTypes.string,
    number: PropTypes.string,
  }),
  index: PropTypes.number,
};

export default ContactModalPhonesForm;